// import { useState } from "react";
// import { motion } from "framer-motion";
// import emailjs from "@emailjs/browser";

// import AboutBg from "../../../Assets/Home/AboutBg.png";

// export default function ContactSection() {
//   const [form, setForm] = useState({
//     name: "",
//     contact: "",
//     email: "",
//     company: "",
//     message: "",
//   });

//   const [errors, setErrors] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [success, setSuccess] = useState("");

//   // ─────────────────────────────────────────────
//   // Validation
//   // ─────────────────────────────────────────────
//   const validate = () => {
//     let newErrors = {};

//     // Name
//     if (!form.name.trim()) {
//       newErrors.name = "Name is required";
//     } else if (form.name.trim().length < 3) {
//       newErrors.name = "Name must be at least 3 characters";
//     }

//     // Email
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     if (!form.email.trim()) {
//       newErrors.email = "Email is required";
//     } else if (!emailRegex.test(form.email)) {
//       newErrors.email = "Enter a valid email";
//     }

//     // Contact
//     const phoneRegex = /^[0-9]{10}$/;
//     if (!form.contact.trim()) {
//       newErrors.contact = "Contact number is required";
//     } else if (!phoneRegex.test(form.contact)) {
//       newErrors.contact = "Enter valid 10 digit number";
//     }

//     setErrors(newErrors);

//     return Object.keys(newErrors).length === 0;
//   };

//   // ─────────────────────────────────────────────
//   // Handle Change
//   // ─────────────────────────────────────────────
//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     setForm((prev) => ({
//       ...prev,
//       [name]: value,
//     }));

//     setErrors((prev) => ({
//       ...prev,
//       [name]: "",
//     }));
//   };

//   // ─────────────────────────────────────────────
//   // EmailJS Submit
//   // ─────────────────────────────────────────────
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!validate()) return;

//     try {
//       setLoading(true);

//       await emailjs.send(
//         "service_xccirpg",
//         "template_n3tslyf",
//         {
//           from_name: form.name,
//           from_email: form.email,
//           contact: form.contact,
//           company: form.company || "Not Provided",
//           message: form.message || "No message added",
//         },
//         "XkYTBlLQFelDc5Avb"
//       );

//       setSuccess("Message sent successfully 🎉");

//       setForm({
//         name: "",
//         contact: "",
//         email: "",
//         company: "",
//         message: "",
//       });
//     } catch (error) {
//       console.log(error);
//       alert("Something went wrong!");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <section className="w-full bg-gradient-to-b from-white to-gray-50 py-12 lg:py-20 overflow-hidden">
//       <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-16 items-center">
        
//         {/* ───────────────── LEFT CONTENT ───────────────── */}
//         <motion.div
//           initial={{ opacity: 0, x: -40 }}
//           whileInView={{ opacity: 1, x: 0 }}
//           viewport={{ once: true }}
//           transition={{ duration: 0.6 }}
//           className="w-full"
//         >
//             <motion.div
//             initial={{ opacity: 0, y: -12 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             transition={{ duration: 0.45 }}
//             className="mb-2"
//           >
//             <span className="inline-block px-5 py-1.5 rounded-full border border-gray-300 bg-gray-50 text-gray-600 text-xs font-semibold tracking-widest uppercase">
//               Get In Touch
//             </span>
//           </motion.div>

//           {/* Heading */}
//           <h2 className="mt-6 text-4xl lg:text-[45px] font-bold leading-tight text-gray-900">
//             We’d love to hear from you
//           </h2>

//           {/* Description */}
//           <p className="mt-5 text-gray-600 leading-relaxed text-[15px] max-w-xl">
//             Thank you for your interest in KGS Technologies. We deliver
//             world-class IT consulting, offshore development, and custom digital
//             solutions for modern businesses worldwide.
//           </p>

//           {/* FORM */}
//           <motion.form
//             onSubmit={handleSubmit}
//             initial={{ opacity: 0, y: 30 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             transition={{ duration: 0.5, delay: 0.2 }}
//             className="mt-5 bg-white p-6 lg:p-8 rounded-3xl shadow-[0_10px_40px_rgba(0,0,0,0.08)] border border-gray-100 space-y-5"
//           >
//             {/* Name + Contact */}
//             <div className="grid sm:grid-cols-2 gap-5">
//               <div>
//                 <label className="text-sm font-semibold text-gray-700 mb-2 block">
//                   Full Name *
//                 </label>

//                 <input
//                   type="text"
//                   name="name"
//                   value={form.name}
//                     onChange={(e) => {
//                     let value = e.target.value;

//                     // Allow only letters and spaces
//                     value = value.replace(/[^A-Za-z\s]/g, "");

//                     handleChange({
//                       target: {
//                         name: "name",
//                         value,
//                       },
//                     });
//                   }}
                
//                   className={`w-full px-4 py-3 rounded-xl border bg-gray-50 focus:outline-none focus:ring-2 transition-all ${
//                     errors.name
//                       ? "border-red-400 focus:ring-red-200"
//                       : "border-gray-200 focus:ring-blue-200 focus:border-blue-400"
//                   }`}
//                 />

//                 {errors.name && (
//                   <p className="text-red-500 text-sm mt-1">{errors.name}</p>
//                 )}
//               </div>

//               <div>
//                 <label className="text-sm font-semibold text-gray-700 mb-2 block">
//                   Contact *
//                 </label>

//                 <input
//                     type="tel"
//                     name="contact"
//                     value={form.contact}
//                     onChange={(e) => {
//                       let value = e.target.value;

//                       // Allow only numbers and one "+"
//                       value = value.replace(/[^\d+]/g, "");

//                       // Prevent multiple "+"
//                       if ((value.match(/\+/g) || []).length > 1) {
//                         value = value.replace(/\+/g, "");
//                         value = "+" + value;
//                       }

//                       // "+" only at beginning
//                       if (value.includes("+") && value[0] !== "+") {
//                         value = "+" + value.replace(/\+/g, "");
//                       }

//                       handleChange({
//                         target: {
//                           name: "contact",
//                           value,
//                         },
//                       });
//                     }}
                    
//                     className={`w-full px-4 py-3 rounded-xl border bg-gray-50 focus:outline-none focus:ring-2 transition-all ${
//                       errors.contact
//                         ? "border-red-400 focus:ring-red-200"
//                         : "border-gray-200 focus:ring-blue-200 focus:border-blue-400"
//                     }`}
//                   />

//                 {errors.contact && (
//                   <p className="text-red-500 text-sm mt-1">
//                     {errors.contact}
//                   </p>
//                 )}
//               </div>
//             </div>

//             {/* Email + Company */}
//             <div className="grid sm:grid-cols-2 gap-5">
//               <div>
//                 <label className="text-sm font-semibold text-gray-700 mb-2 block">
//                   Email *
//                 </label>

//                 <input
//                   type="email"
//                   name="email"
//                   value={form.email}
//                   onChange={handleChange}
                  
//                   className={`w-full px-4 py-3 rounded-xl border bg-gray-50 focus:outline-none focus:ring-2 transition-all ${
//                     errors.email
//                       ? "border-red-400 focus:ring-red-200"
//                       : "border-gray-200 focus:ring-blue-200 focus:border-blue-400"
//                   }`}
//                 />

//                 {errors.email && (
//                   <p className="text-red-500 text-sm mt-1">{errors.email}</p>
//                 )}
//               </div>

//               <div>
//                 <label className="text-sm font-semibold text-gray-700 mb-2 block">
//                   Company
//                 </label>

//                 <input
//                   type="text"
//                   name="company"
//                   value={form.company}
//                   onChange={handleChange}
                  
//                   className="w-full px-4 py-3 rounded-xl border border-gray-200 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-200 focus:border-blue-400 transition-all"
//                 />
//               </div>
//             </div>

//             {/* Message */}
//             <div>
//               <label className="text-sm font-semibold text-gray-700 mb-2 block">
//                 Message
//               </label>

//               <textarea
//                 name="message"
//                 value={form.message}
//                 onChange={handleChange}
//                 rows={4}
               
//                 className="w-full px-4 py-3 rounded-xl border border-gray-200 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-200 focus:border-blue-400 transition-all resize-none"
//               />
//             </div>

//             {/* Success */}
//             {success && (
//               <p className="text-green-600 font-medium">{success}</p>
//             )}

//              <div>
//                <motion.button
//                   type="submit"
//                   whileHover={{ scale: 1.03 }}
//                   whileTap={{ scale: 0.96 }}
//                   disabled={loading}
//                  transition={{ type: "spring", stiffness: 300, damping: 22 }}
//                  className="px-8 py-3 rounded-full border-2 border-gray-800 text-gray-900 font-semibold text-[0.97rem] cursor-pointer select-none"
//                  style={{ transition: "background-color 0.2s, color 0.2s, border-color 0.2s" }}
//                >
//                {loading ? "Sending..." : "Send Message"}
//                </motion.button>
//              </div>
//           </motion.form>
//         </motion.div>

//         {/* ───────────────── RIGHT IMAGE ───────────────── */}
//         <motion.div
//           initial={{ opacity: 0, x: 40 }}
//           whileInView={{ opacity: 1, x: 0 }}
//           viewport={{ once: true }}
//           transition={{ duration: 0.7 }}
//           className="relative flex justify-center items-center"
//         >
//           {/* Background Shape */}
//           <div
//             style={{ backgroundImage: `url(${AboutBg})` }}
//             className="absolute inset-0 bg-contain bg-center bg-no-repeat opacity-30 scale-110"
//           />

//           {/* Decorative blur */}
//           <div className="absolute w-72 h-72 bg-blue-200/30 rounded-full blur-3xl -top-10 -left-10" />

//           {/* Main image */}
//           <motion.div
//             whileHover={{ scale: 1.02 }}
//             transition={{ type: "spring", stiffness: 180, damping: 18 }}
//             className="relative z-10 w-full max-w-md rounded-[30px] overflow-hidden shadow-[0_20px_80px_rgba(0,0,0,0.18)]"
//           >
//             <img
//               src="https://images.unsplash.com/photo-1556761175-4b46a572b786?w=1200&q=90"
//               alt="Business Team"
//               className="w-full h-[580px] object-cover"
//             />
//           </motion.div>
//         </motion.div>
//       </div>
//     </section>
//   );
// }

import { useState } from "react";
import { motion } from "framer-motion";
import emailjs from "@emailjs/browser";
import ReCAPTCHA from "react-google-recaptcha";

import AboutBg from "../../../Assets/Home/AboutBg.png";

export default function ContactSection() {
  const [form, setForm] = useState({
    name: "",
    contact: "",
    email: "",
    company: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [captchaValue, setCaptchaValue] = useState(null);

  // ───────────────── VALIDATION ─────────────────
  const validate = () => {
    let newErrors = {};

    // Name
    const nameRegex = /^[A-Za-z\s]+$/;

    if (!form.name.trim()) {
      newErrors.name = "Full name is required";
    } else if (form.name.trim().length < 3) {
      newErrors.name = "Name must be at least 3 characters";
    } else if (!nameRegex.test(form.name.trim())) {
      newErrors.name = "Only letters are allowed";
    }

    // Email
    const emailRegex =
      /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

    if (!form.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(form.email.trim())) {
      newErrors.email = "Enter a valid email";
    }

    // International Phone
    const cleanedPhone = form.contact.replace(/\s+/g, "");

    const phoneRegex = /^\+?[1-9]\d{7,14}$/;

    if (!cleanedPhone) {
      newErrors.contact = "Phone number is required";
    } else if (!phoneRegex.test(cleanedPhone)) {
      newErrors.contact = "Enter valid phone number";
    }

    // Captcha
    if (!captchaValue) {
      newErrors.captcha = "Please verify captcha";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  // ───────────────── HANDLE CHANGE ─────────────────
  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  // ───────────────── SUBMIT ─────────────────
  const handleSubmit = async (e) => {
    e.preventDefault();

    setSuccess("");

    if (!validate()) return;

    try {
      setLoading(true);

      await emailjs.send(
        "service_xccirpg",
        "template_n3tslyf",
        {
          from_name: form.name,
          from_email: form.email,
          contact: form.contact,
          company: form.company || "Not Provided",
          message: form.message || "No message added",
        },
        "XkYTBlLQFelDc5Avb"
      );

      setSuccess("Message sent successfully 🎉");

      setForm({
        name: "",
        contact: "",
        email: "",
        company: "",
        message: "",
      });

      setCaptchaValue(null);
    } catch (error) {
      console.log(error);
      alert("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="w-full bg-gradient-to-b from-white to-gray-50 py-12 lg:py-12 overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-16 items-center">

        {/* LEFT */}
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          {/* <span className="inline-block px-5 py-1.5 rounded-full border border-gray-300 bg-gray-50 text-gray-600 text-xs font-semibold tracking-widest uppercase">
            Get In Touch
          </span> */}

          <h2 className="mt-6 text-4xl lg:text-[45px] font-bold leading-tight text-gray-900">
            We’d love to hear from you
          </h2>

          <p className="mt-5 text-gray-600 leading-relaxed text-[15px] max-w-xl">
            Thank you for your interest in KGS Technologies.
          </p>

          {/* FORM */}
          <motion.form
            onSubmit={handleSubmit}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="mt-5 bg-white p-6 lg:p-8 rounded-3xl shadow-[0_10px_40px_rgba(0,0,0,0.08)] border border-gray-100 space-y-5"
          >

            {/* Name + Contact */}
            <div className="grid sm:grid-cols-2 gap-5">

              {/* NAME */}
              <div>
                <label className="text-sm font-semibold text-gray-700 mb-2 block">
                  Full Name *
                </label>

                <input
                  type="text"
                  name="name"
                  value={form.name}
                  maxLength={50}
                  onChange={(e) => {
                    let value = e.target.value;

                    value = value.replace(/[^A-Za-z\s]/g, "");
                    value = value.replace(/\s{2,}/g, " ");

                    handleChange({
                      target: {
                        name: "name",
                        value,
                      },
                    });
                  }}
                  className={`w-full px-4 py-3 rounded-xl border bg-gray-50 focus:outline-none focus:ring-2 transition-all ${
                    errors.name
                      ? "border-red-400 focus:ring-red-200"
                      : "border-gray-200 focus:ring-blue-200"
                  }`}
                />

                {errors.name && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.name}
                  </p>
                )}
              </div>

              {/* PHONE */}
              <div>
                <label className="text-sm font-semibold text-gray-700 mb-2 block">
                  Contact *
                </label>

                <input
                  type="tel"
                  name="contact"
                  value={form.contact}
                  // placeholder="+1 2025550123"
                  onChange={(e) => {
                    let value = e.target.value;

                    value = value.replace(/[^\d+]/g, "");

                    if (value.includes("+")) {
                      value =
                        "+" +
                        value.replace(/\+/g, "").replace(/^\+/, "");
                    }

                    value = value.slice(0, 16);

                    handleChange({
                      target: {
                        name: "contact",
                        value,
                      },
                    });
                  }}
                  className={`w-full px-4 py-3 rounded-xl border bg-gray-50 focus:outline-none focus:ring-2 transition-all ${
                    errors.contact
                      ? "border-red-400 focus:ring-red-200"
                      : "border-gray-200 focus:ring-blue-200"
                  }`}
                />

                {errors.contact && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.contact}
                  </p>
                )}
              </div>
            </div>

            {/* EMAIL + COMPANY */}
            <div className="grid sm:grid-cols-2 gap-5">

              {/* EMAIL */}
              <div>
                <label className="text-sm font-semibold text-gray-700 mb-2 block">
                  Email *
                </label>

                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={(e) => {
                    handleChange({
                      target: {
                        name: "email",
                        value: e.target.value.trimStart(),
                      },
                    });
                  }}
                  className={`w-full px-4 py-3 rounded-xl border bg-gray-50 focus:outline-none focus:ring-2 transition-all ${
                    errors.email
                      ? "border-red-400 focus:ring-red-200"
                      : "border-gray-200 focus:ring-blue-200"
                  }`}
                />

                {errors.email && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.email}
                  </p>
                )}
              </div>

              {/* COMPANY */}
              <div>
                <label className="text-sm font-semibold text-gray-700 mb-2 block">
                  Company
                </label>

                <input
                  type="text"
                  name="company"
                  value={form.company}
                  onChange={handleChange}
                  className="w-full px-4 py-3 rounded-xl border border-gray-200 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-200"
                />
              </div>
            </div>

            {/* MESSAGE */}
            <div>
              <label className="text-sm font-semibold text-gray-700 mb-2 block">
                Message
              </label>

              <textarea
                name="message"
                value={form.message}
                rows={4}
                onChange={handleChange}
                className="w-full px-4 py-3 rounded-xl border border-gray-200 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-200 resize-none"
              />
            </div>

            {/* CAPTCHA */}
            <div>
              <ReCAPTCHA
                sitekey="6LcJ0PMsAAAAAJG_aTmNuk1JqMiETgJCXf5bVkFz"
                onChange={(value) => {
                  setCaptchaValue(value);

                  setErrors((prev) => ({
                    ...prev,
                    captcha: "",
                  }));
                }}
              />

              {errors.captcha && (
                <p className="text-red-500 text-sm mt-2">
                  {errors.captcha}
                </p>
              )}
            </div>

            {/* SUCCESS */}
            {success && (
              <p className="text-green-600 font-medium">
                {success}
              </p>
            )}

            {/* BUTTON */}
            <motion.button
              type="submit"
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.96 }}
              disabled={loading}
              className="px-8 py-3 rounded-full border-2 border-gray-800 text-gray-900 font-semibold disabled:opacity-60"
            >
              {loading ? "Sending..." : "Send Message"}
            </motion.button>
          </motion.form>
        </motion.div>

        {/* RIGHT IMAGE */}
        <motion.div
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="relative flex justify-center items-center"
        >
          <div
            style={{ backgroundImage: `url(${AboutBg})` }}
            className="absolute inset-0 bg-contain bg-center bg-no-repeat opacity-30 scale-110"
          />

          <div className="absolute w-72 h-72 bg-blue-200/30 rounded-full blur-3xl -top-10 -left-10" />

          <motion.div
            whileHover={{ scale: 1.02 }}
            className="relative z-10 w-full max-w-md rounded-[30px] overflow-hidden shadow-[0_20px_80px_rgba(0,0,0,0.18)]"
          >
            <img
              src="https://images.unsplash.com/photo-1556761175-4b46a572b786?w=1200&q=90"
              alt="Business Team"
              className="w-full h-[580px] object-cover"
            />
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}